import React, { JSX } from 'react';
import { Badge, Td, Text, VStack } from '@chakra-ui/react';

import { useTranslations } from '../../../contexts/LocalizationContext';
import { formatWeekRange } from '../utils/metrics';

interface Props {
  weekNumber: number;
  weekStart: string;
  weekEnd: string;
  isLatest: boolean;
}

const WeekCell = ({ weekNumber, weekStart, weekEnd, isLatest }: Props): JSX.Element => {
  const translations = useTranslations();

  return (
    <Td>
      <VStack align="start" spacing={0}>
        <Text>
          CW {weekNumber}
          {isLatest && (
            <Badge ml={2} colorScheme="green" fontSize="2xs" verticalAlign="middle">
              {translations('monitoring_table_latest')}
            </Badge>
          )}
        </Text>
        <Text fontSize="xs" color="grey.200">
          {formatWeekRange(weekStart, weekEnd)}
        </Text>
      </VStack>
    </Td>
  );
};

export default WeekCell;
